<template>
  <div class="box">
    <div class="main-content">
      <!-- 资源类型部分开始 -->
      <div class="publicMarginTop">
        <div class="flex align justify">
          <div class="flex">
            <div class="requiredIcon">*</div>
            <div class="informationTxt">资源类型:</div>
          </div>
          <div class="main-content-right">
            <div v-show="editableOrNot" class="resourceType-box flex spaceBetween">
              <div @click="selectResources(1)" :class="this.selectResource == 'video' ? 'selectType' : 'unSelectType'">
                视频资源</div>
              <div @click="selectResources(2)" :class="this.selectResource == 'audio' ? 'selectType' : 'unSelectType'">
                音频资源</div>
              <div @click="selectResources(3)" :class="this.selectResource == 'doc' ? 'selectType' : 'unSelectType'">
                文档资源</div>
              <div @click="selectResources(4)" :class="this.selectResource == 'image' ? 'selectType' : 'unSelectType'">
                图片资源</div>
            </div>
            <div v-show="!editableOrNot" class="resourceType-box flex spaceBetween">
              <div :class="this.selectResource == 'video' ? 'superSelectType' : 'superUnSelectType'">视频资源</div>
              <div :class="this.selectResource == 'audio' ? 'superSelectType' : 'superUnSelectType'">音频资源</div>
              <div :class="this.selectResource == 'doc' ? 'superSelectType' : 'superUnSelectType'">文档资源</div>
              <div :class="this.selectResource == 'image' ? 'superSelectType' : 'superUnSelectType'">图片资源</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 资源类型部分结束 -->
      <!-- 资源名称部分开始 -->
      <div class="publicMarginTop">
        <div class="flex align justify">
          <div class="flex">
            <div class="requiredIcon">*</div>
            <div class="informationTxt">资源名称:</div>
          </div>
          <div class="main-content-right">
            <div class="publicInput-box">
              <input v-show="editableOrNot" v-model="resourceName" class="publicInput" type="text"
                placeholder="请输入资源名称" />
              <input v-show="!editableOrNot" disabled v-model="resourceName" class="publicInput" type="text"
                placeholder="请输入资源名称" />
            </div>
          </div>
        </div>
      </div>
      <!-- 资源名称部分结束 -->
      <!-- 资源分值部分开始 -->
      <div class="publicMarginTop">
        <div class="flex align justify">
          <div class="flex">
            <div class="requiredIcon">*</div>
            <div class="informationTxt">资源分值:</div>
          </div>
          <div class="flex main-content-right">
            <input v-show="editableOrNot" class="resourceScore-range" @input="resourceScoreInput"
              :value="resourceScore || 0" type="range" min="0" max="100" />
            <input v-show="!editableOrNot" class="resourceScore-range" disabled @input="resourceScoreInput"
              :value="resourceScore || 0" type="range" min="0" max="100" />
            <input v-show="editableOrNot" onBlur="if(value == '')value = 0" class="resourceScore-text"
              v-model="resourceScore"
              oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/\D/g,'');if(value>100)value=100;if(value<0)value=0" />
            <input v-show="!editableOrNot" disabled class="resourceScore-text" v-model="resourceScore" />
          </div>
        </div>
      </div>
      <!-- 资源分值部分结束 -->
      <!-- 得分设置部分开始 -->
      <div v-show="showScoresetting" class="publicMarginTop">
        <div class="flex justify" style="flex-direction: column">
          <div class="flex align">
            <div class="flex">
              <div class="requiredIcon">*</div>
              <div class="informationTxt">得分设置:</div>
            </div>
            <div class="flex main-content-right">
              <input v-show="editableOrNot" class="resourceScore-range" @input="scoreSettingInput"
                :value="scoreSetting || 0" type="range" min="0" max="100" />
              <input v-show="!editableOrNot" class="resourceScore-range" disabled @input="scoreSettingInput"
                :value="scoreSetting || 0" type="range" min="0" max="100" />
              <input v-show="editableOrNot" onBlur="if(value == '')value = 0" class="resourceScore-text1"
                v-model="scoreSettingTxt" @change="scoreSetting = scoreSettingTxt"
                oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/\D/g,'');if(value>100)value=100;if(value<0)value=0" />
              <input v-show="!editableOrNot" disabled class="resourceScore-text1" v-model="scoreSettingTxt" />
            </div>
          </div>
          <div class="tips">查看多少后才可获得分值</div>
        </div>
      </div>
      <!-- 得分设置部分结束 -->
      <!-- 所属课次部分开始 -->
      <div class="publicMarginTop">
        <div class="flex align justify">
          <div class="flex">
            <div class="requiredIcon">*</div>
            <div class="informationTxt">所属课次:</div>
          </div>
          <div class="main-content-right">
            <van-popover close-on-click-outside placement="bottom-start" v-model="showPopover">
              <div class="selectClass-box">
                <van-checkbox-group class="van-checkbox" v-for="(item, index) in classList" :key="index"
                  v-model="checked">
                  <van-checkbox @click="changeCheckbox(item.name, item.id)" shape="square" :name="item.name">课次 {{ index
              + 1 }} {{ item.name }}</van-checkbox>
                </van-checkbox-group>
              </div>
              <template #reference>
                <div v-show="editableOrNot" @click="showPopover = true" class="publicInput-box flex align spaceBetween">
                  <input v-model="checked" disabled class="publicInput" type="text" placeholder="请选择所属课次" />
                  <img @click="showPopover = true" style="margin-right: 17px"
                    src="../../assets/courseInformation/add.png" />
                </div>
                <div v-show="!editableOrNot" class="publicInput-box flex align spaceBetween">
                  <input v-model="checked" disabled class="publicInput" type="text" placeholder="请选择所属课次" />
                  <img style="margin-right: 17px" src="../../assets/courseInformation/add.png" />
                </div>
              </template>
            </van-popover>
          </div>
        </div>
      </div>
      <!-- 所属课次部分结束 -->
      <!-- 资源用途部分开始 -->
      <div class="publicMarginTop">
        <div class="flex align justify">
          <div class="flex">
            <div class="requiredIcon">*</div>
            <div class="informationTxt">资源用途:</div>
          </div>
          <div class="main-content-right">
            <div v-show="editableOrNot" class="useResources-box flex spaceBetween">
              <div @click="useResources = 'front'" class="flex align pointer">
                <div :class="this.useResources == 'front' ? 'selectUseCircle' : 'unSelectUseCircle'"></div>
                <div :class="this.useResources == 'front' ? 'selectUseTxt' : 'unSelectUseTxt'">课前</div>
              </div>
              <div @click="useResources = 'middle'" class="flex align pointer">
                <div :class="this.useResources == 'middle' ? 'selectUseCircle' : 'unSelectUseCircle'"></div>
                <div :class="this.useResources == 'middle' ? 'selectUseTxt' : 'unSelectUseTxt'">课中</div>
              </div>
              <div @click="useResources = 'back'" class="flex align pointer">
                <div :class="this.useResources == 'back' ? 'selectUseCircle' : 'unSelectUseCircle'"></div>
                <div :class="this.useResources == 'back' ? 'selectUseTxt' : 'unSelectUseTxt'">课后</div>
              </div>
            </div>
            <div v-show="!editableOrNot" class="useResources-box flex spaceBetween">
              <div class="flex align pointer" style="cursor: not-allowed">
                <div :class="this.useResources == 'front' ? 'selectUseCircle' : 'unSelectUseCircle'"></div>
                <div :class="this.useResources == 'front' ? 'selectUseTxt' : 'unSelectUseTxt'">课前</div>
              </div>
              <div class="flex align pointer" style="cursor: not-allowed">
                <div :class="this.useResources == 'middle' ? 'selectUseCircle' : 'unSelectUseCircle'"></div>
                <div :class="this.useResources == 'middle' ? 'selectUseTxt' : 'unSelectUseTxt'">课中</div>
              </div>
              <div class="flex align pointer" style="cursor: not-allowed">
                <div :class="this.useResources == 'back' ? 'selectUseCircle' : 'unSelectUseCircle'"></div>
                <div :class="this.useResources == 'back' ? 'selectUseTxt' : 'unSelectUseTxt'">课后</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 资源用途部分结束 -->
      <!-- 资源上传部分开始 -->
      <div class="publicMarginTop">
        <div class="flex justify" style="flex-direction: column">
          <div class="flex">
            <div class="flex">
              <div class="requiredIcon">*</div>
              <div class="informationTxt">资源上传:</div>
            </div>
            <div class="main-content-right">
              <!-- 封面上传 -->
              <div class="flex">
                <!-- 视频资源 音频资源展示 -->
                <video v-if="this.selectResource == 'video' || this.selectResource == 'audio'" id="myVideo"
                  class="cover" controls :src="coverSrc"></video>
                <!-- 文档资源展示 -->
                <iframe v-if="this.selectResource == 'doc'" class="cover" :src="coverSrc"></iframe>
                <!-- 图片资源展示 -->
                <img v-if="this.selectResource == 'image'" class="cover" :src="coverSrc" />
                <!-- <div class="btnUploadfile" @click="btnUploadfile">上传文件</div> -->
                <div v-show="editableOrNot" class="btnUploadfile" @click="uploadFile">上传文件</div>
                <!-- <input ref="coverInput" :value="cover_input" class="cover-input" type="file" :accept="inputAccept" @change="uploadWorks" /> -->
              </div>
            </div>
          </div>
          <div class="tips" style="margin-top: 10px">{{ resourceUploadTxt }}</div>
        </div>
      </div>
      <!-- 资源上传部分结束 -->
      <!-- 按钮 -->
      <div v-show="editableOrNot" class="btn-box flex spaceBetween">
        <div @click="btnUpload" class="pushButton pointer">上传</div>
        <div @click="btnCancel" class="pushButton pointer">取消</div>
      </div>
      <div v-show="!editableOrNot" class="btn-box flex justify">
        <div @click="btnCancel" class="pushButton pointer">返回</div>
      </div>
    </div>
    <!-- <button @click="uploadFile">上传</button> -->
  </div>
</template>

<script>
import uploadFile22 from "@/utils/uploadFile22.js";
import { base64toFile, filetoBase64 } from "@/utils/util.js";
import { Toast } from "vant";
import { ref } from "vue";
import "@vant/touch-emulator";
import { resourceAddition, resourceModification, resourceAssociationAdd, resourceAssociationDel } from "@/api";
export default {
  data() {
    return {
      editableOrNot: true, // 是否可编辑
      identity: "", // 登录身份
      checked: [],
      selectResource: "", // 选中的资源类型
      resourceName: "", // 资源名称
      resourceScore: 0, // 资源分值
      scoreSetting: 0, // 得分设置
      scoreSettingTxt: "0%", // 得分设置Txt
      useResources: "", // 选中的资源用途
      coverSrc: require("../../assets/uploadCover.png"), // 封面地址
      resourceUploadTxt: "视频仅支持MP4文件，H.264+ACC，建议大小1280*720", // 资源上传提示
      inputAccept: "video/mp4", // input接受的值
      showScoresetting: true, // 控制得分设置的显示
      showVideoAudio: true, // 控制视频、音频资源展示的显示
      showFile: false, // 控制文档资源展示的显示
      showImage: false, // 控制图片资源展示的显示
      coverNet: "", // 资源的网络路径
      cover_input: "",
      classList: [], // 课次列表
      classesList: [],
      showPopover: false,
    };
  },
  created() {
    this.editableOrNot = this.$store.state.editableOrNot; // 获取是否可编辑状态
    // 获取登录身份
    this.identity = this.$store.state.loginRecord.data.datas.identity;
    this.classList = this.$store.state.classListRecord;

    // 从store获取选中的课次ID并自动选中
    const selectedClassTimeId = this.$store.state.classTimesId;
    if (selectedClassTimeId && !this.$route.params.record) {
      // 找到对应的课次并选中
      const selectedClass = this.classList.find(item => item.id === selectedClassTimeId);
      if (selectedClass) {
        this.checked.push(selectedClass.name);
        this.classesList.push(selectedClass.id);
      }
    }

    if (this.$route.params.record) {
      let record = this.$route.params.record;
      this.resourceName = record.name; // 资源名称
      this.scoreSetting = record.percent; // 资源分值
      this.scoreSettingTxt = record.percent + "%"; // 得分设置Txt
      this.resourceScore = record.score.replace("分", "");
      for (let i = 0; i < record.lesson_items.length; i++) {
        this.checked.push(record.lesson_items[i].name);
      }
      if (record.usage == "课前") {
        this.useResources = "front";
      } else if (record.usage == "课中") {
        this.useResources = "middle";
      } else if (record.usage == "课后") {
        this.useResources = "back";
      }
      if (record.types == "视频资源") {
        this.selectResources(1);
        this.coverSrc = record.content[0];
        this.coverNet = record.content[0];
      } else if (record.types == "音频资源") {
        this.selectResources(2);
        this.coverSrc = record.content[0];
        this.coverNet = record.content[0];
      } else if (record.types == "文档资源") {
        this.selectResources(3);
        this.coverSrc = record.content[0];
        this.coverNet = record.content[0];
      } else if (record.types == "图片资源") {
        this.selectResources(4);
        this.coverSrc = record.content[0];
        this.coverNet = record.content[0];
      }
    }
    if (this.$route.params.whetherModified) {
      if (this.$route.params.whetherModified == "no") {
        this.editableOrNot = false;
      }
    }
  },
  methods: {
    uploadFile() {
      //资源上传
      // let sign = new Date().getTime();
      let params = {
        accept: this.inputAccept, //上传的文件类型
        // onUploadProgress: this.onUploadProgress, //上传进度回调
        uploadSuccess: this.uploadSuccess, //上传成功回调
        // ext: { sign }, // 自定义回传参数
      };
      uploadFile22(params)
        .then(({ file, ext }) => {
          filetoBase64(file).then((base64) => {
            this.coverSrc = base64;
          });
          var loading = this.$loading({
            lock: true,
            text: "资源上传中...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
        })
        .catch((error) => {
          alert(error);
        });
    },
    // onUploadProgress({ event, ext }) {
    //   //监听上传进度
    //   // let index = this.form.pic1.map((item) => item.ext.sign).indexOf(ext.sign);
    //   // if (index != -1) this.form.pic1[index].plan = (event.progress * 100).toFixed(0);
    // },
    uploadSuccess({ data, ext }) {
      this.$loading().close();
      //上传完成
      this.coverNet = data.datas;
    },
    // 更改资源所属课次
    changeCheckbox(classIdx, idx) {
      if (this.classesList.indexOf(idx) > -1) {
        this.classesList.splice(this.classesList.indexOf(idx), 1);
      } else {
        this.classesList.push(idx);
      }
      console.log(this.classesList);
      if (this.$route.params.record) {
        // console.log("当前选中的课次", classIdx);
        // console.log("课次数组", this.checked);
        // console.log("当前选中的课次下标", this.checked.indexOf(classIdx));
        if (this.checked.indexOf(classIdx) === -1) {
          // 删除习题课次关联
          let data = { resource_id: this.$route.params.record.id, lesson_item_id: idx, types: "assets" };
          resourceAssociationDel(data).then((res) => { });
        } else {
          // 添加习题课次关联
          let data = {
            resource_id: this.$route.params.record.id,
            lesson_item_id: idx,
            lesson_id: this.$store.state.courseDetails.id,
            types: "assets",
          };
          resourceAssociationAdd(data).then((res) => { });
        }
      }
    },
    // 资源分值滑块
    resourceScoreInput(event) {
      let dom = document.getElementsByClassName("resourceScore-range")[0];
      let value = dom.value;
      if (value) this.resourceScore = value;
    },
    // 得分设置滑块
    scoreSettingInput(event) {
      let dom = document.getElementsByClassName("resourceScore-range")[2];
      let value = dom.value;
      if (value) this.scoreSetting = value;
      this.scoreSettingTxt = value + "%";
    },
    // 上传文件
    btnUploadfile() {
      this.$refs.coverInput.click();
    },
    // 1.视频资源 2.音频资源 3.文档资源 4.图片资源
    selectResources(idx) {
      let record = this.$route.params.record;
      if (!record) {
        record = { types: "", status: false };
      } else {
        record.status = true;
      }
      if (idx == 1) {
        if (record.types != "视频资源" && record.status) return;
        this.selectResource = "video";
        this.showScoresetting = true; // 控制得分设置的显示
        this.inputAccept = "video/mp4"; // 上传接受的文件类型
        this.resourceUploadTxt = "视频仅支持MP4文件，H.264+ACC，建议大小1280*720";
        this.showVideoAudio = true;
        this.showFile = false;
        this.showImage = false;
        this.coverSrc = "";
        this.coverNet = "";
      } else if (idx == 2) {
        if (record.types != "音频资源" && record.status) return;
        this.selectResource = "audio";
        this.showScoresetting = true; // 控制得分设置的显示
        this.inputAccept = "audio/*"; // 上传接受的文件类型
        this.resourceUploadTxt = "音频仅支持MP3文件";
        this.showVideoAudio = true;
        this.showFile = false;
        this.showImage = false;
        this.coverSrc = "";
        this.coverNet = "";
      } else if (idx == 3) {
        if (record.types != "文档资源" && record.status) return;
        this.selectResource = "doc";
        this.showScoresetting = false; // 控制得分设置的显示
        this.inputAccept = ""; // 上传接受的文件类型
        this.resourceUploadTxt = "文档仅支持doc/docx/pdf文件，建议大小不超过10M";
        this.showVideoAudio = false;
        this.showFile = true;
        this.showImage = false;
        this.coverSrc = "";
        this.coverNet = "";
      } else if (idx == 4) {
        if (record.types != "图片资源" && record.status) return;
        this.selectResource = "image";
        this.showScoresetting = false; // 控制得分设置的显示
        this.inputAccept = "image/jpeg,image/png"; // 上传接受的文件类型
        this.resourceUploadTxt = "图片仅支持jpeg/png文件，建议大小不超过5M";
        this.showVideoAudio = false;
        this.showFile = false;
        this.showImage = true;
        this.coverSrc = require("../../assets/uploadCover.png");
        this.coverNet = "";
      }
    },
    // 上传按钮
    btnUpload() {
      if (this.resourceName != "" && this.checked.length != 0 && this.useResources != "" && this.coverNet != "" && this.selectResource != "" && this.$store.state.courseDetails.id != "") {
        if (!this.$route.params.record) {
          let total1 = "";
          for (let i = 0; i < this.classesList.length; i++) {
            total1 += this.classesList[i] + ",";
          }
          if (this.selectResource == "video" || this.selectResource == "audio") {
            let myVideo = document.getElementById("myVideo"); // 获取视频、音频总时长
            let data = {
              name: this.resourceName, // 资源名称
              score: this.resourceScore, // 分值
              percent: this.scoreSettingTxt, // 得分设置百分比
              percent_value: Math.floor(myVideo.duration), // 视频、音频总时长
              lesson_item_ids: total1, // 所属课次
              usage: this.useResources, // 用途
              content: this.coverNet, // 内容
              types: this.selectResource, // 资源类型
              lesson_id: this.$store.state.courseDetails.id, // 课程id
            };
            resourceAddition(data).then((res) => {
              if (res.data.code == 0) {
                if (this.$route.params.comeFrom == "prepareLessons") {
                  this.$router.push({
                    name: "courseTeaching",
                    params: {},
                  });
                } else {
                  this.$router.push("/resourceManagement");
                  Toast("上传成功！");
                }
              }
            });
          } else {
            let data = {
              name: this.resourceName, // 资源名称
              score: this.resourceScore, // 分值
              percent: this.scoreSettingTxt, // 得分设置百分比
              lesson_item_ids: total1, // 所属课次
              usage: this.useResources, // 用途
              content: this.coverNet, // 内容
              types: this.selectResource, // 资源类型
              lesson_id: this.$store.state.courseDetails.id, // 课程id
            };
            resourceAddition(data).then((res) => {
              if (res.data.code == 0) {
                if (this.$route.params.comeFrom == "prepareLessons") {
                  this.$router.push({
                    name: "courseTeaching",
                    params: {},
                  });
                } else {
                  this.$router.push("/resourceManagement");
                  Toast("上传成功！");
                }
              }
            });
          }
        } else {
          console.log(this.selectResource);
          if (this.selectResource == "video" || this.selectResource == "audio") {
            let myVideo = document.getElementById("myVideo"); // 获取视频、音频总时长
            let data = {
              name: this.resourceName, // 资源名称
              score: this.resourceScore, // 分值
              percent: this.scoreSetting, // 得分设置百分比
              percent_value: Math.floor(myVideo.duration), // 视频、音频总时长
              usage: this.useResources, // 用途
              content: this.coverNet, // 内容
              types: this.selectResource, // 资源类型
              id: this.$route.params.record.id, // 资源id
            };
            // 资源修改
            resourceModification(data).then((res) => {
              if (res.data.code == 0) {
                this.$router.push("/resourceManagement");
                Toast("修改成功！");
              }
            });
          } else {
            let data = {
              name: this.resourceName, // 资源名称
              score: this.resourceScore, // 分值
              percent: this.scoreSetting, // 得分设置百分比
              usage: this.useResources, // 用途
              content: this.coverNet, // 内容
              types: this.selectResource, // 资源类型
              id: this.$route.params.record.id, // 资源id
            };
            // 资源修改
            resourceModification(data).then((res) => {
              if (res.data.code == 0) {
                this.$router.push("/resourceManagement");
                Toast("修改成功！");
              }
            });
          }
        }
      } else {
        if (this.selectResource == "") {
          Toast("请选择资源类型！");
        } else if (this.resourceName == "") {
          Toast("请输入资源名称!");
        } else if (this.checked.length == 0) {
          Toast("请选择所属课次！");
        } else if (this.useResources == "") {
          Toast("请选择资源用途！");
        } else if (this.coverNet == "") {
          Toast("请上传资源！");
        }
      }
    },
    // 取消按钮
    btnCancel() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.pointer {
  cursor: pointer;
}

::-webkit-scrollbar {
  /*隐藏滚轮*/
  // display: none;
}

.flex {
  display: flex;
}

.column {
  flex-direction: column;
}

.align {
  align-items: center;
}

.justify {
  justify-content: center;
}

.spaceBetween {
  justify-content: space-between;
}

.box {
  width: 100%;
  height: 100%;
  display: flex;
}

.main-content {
  width: 1740px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.11);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.requiredIcon {
  width: 10px;
  height: 10px;
  color: #ff0000;
}

.requiredIcon1 {
  opacity: 0;
}

.informationTxt {
  font-size: 22px;

  font-weight: 400;
  color: #555555;
}

.selectType {
  width: 120px;
  height: 40px;
  background: #349afe;
  border-radius: 10px;
  font-size: 18px;

  font-weight: 400;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}

.superSelectType {
  width: 120px;
  height: 40px;
  background: #349afe;
  border-radius: 10px;
  font-size: 18px;

  font-weight: 400;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  opacity: 0.5;
  cursor: not-allowed;
}

.unSelectType {
  width: 120px;
  height: 40px;
  background: #bbbbbb;
  border-radius: 10px;
  font-size: 18px;

  font-weight: 400;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}

.superUnSelectType {
  width: 120px;
  height: 40px;
  background: #bbbbbb;
  border-radius: 10px;
  font-size: 18px;

  font-weight: 400;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  cursor: not-allowed;
}

.main-content-right {
  width: 761px;
  margin-left: 35px;
}

// 公共输入框样式
.publicInput-box {
  width: 761px;
  height: 40px;
  border: 1px solid #757575;
  border-radius: 10px;
}

.publicInput {
  font-size: 20px;

  font-weight: 400;
  color: #555555;
  margin-left: 17px;
  width: 600px;
  height: 40px;
  border: 1px solid #757575;
  border-radius: 10px;
  background-color: transparent;
  border: 0px;
  outline: none;
}

/* 自定义placeholder的默认样式 */
input::-webkit-input-placeholder {
  color: #666666;
}

// 资源分值滑块
.resourceScore-range {
  display: flex;
  align-items: center;
}

input[type="range"] {
  appearance: none;
  width: 368px;
  border-radius: 10px;
  /*这个属性设置使填充进度条时的图形为圆角*/
}

// 自定义进度条
input[type="range"]::-webkit-slider-runnable-track {
  width: 368px;
  height: 6px;
  background: #dddddd;
  border-radius: 3px;
  cursor: pointer;
}

// 自定义滑块
input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
  /*清除系统默认样式*/
  width: 20px;
  height: 20px;
  background: #349afe;
  border-radius: 50%;
  margin-top: -7px; // 使滑块超出轨道部分的偏移量相等
  cursor: e-resize;
}

// 资源分值输入框
.resourceScore-text {
  margin-left: 24px;
  width: 64px;
  height: 35px;
  border: 1px solid #757575;
  border-radius: 10px;
  font-size: 22px;

  font-weight: 400;
  color: #349afe;
  background-color: transparent;
  outline: none;
  text-align: center;
}

.resourceScore-text1 {
  margin-left: 24px;
  width: 84px;
  height: 35px;
  border: 1px solid #757575;
  border-radius: 10px;
  font-size: 22px;

  font-weight: 400;
  color: #349afe;
  background-color: transparent;
  outline: none;
  text-align: center;
}

.selectUseCircle {
  width: 12px;
  height: 12px;
  background: #349afe;
  border-radius: 50%;
}

.unSelectUseCircle {
  width: 8px;
  height: 8px;
  border: 2px solid #b8b8b8;
  border-radius: 50%;
}

.selectUseTxt {
  margin-left: 6px;
  font-size: 20px;

  font-weight: 400;
  color: #349afe;
}

.unSelectUseTxt {
  margin-left: 6px;
  font-size: 20px;

  font-weight: 400;
  color: #b9b9b9;
}

.cover {
  width: 270px;
  height: 135px;
  border-radius: 10px;
  border: 1px solid #666666;
  object-fit: cover;
}

.cover-input {
  color: #349afe;
  margin-left: 20px;
  width: 80px;
  height: 50px;
  border: 0px;
  outline: none;
  display: none;
}

.tips {
  font-size: 16px;

  font-weight: 400;
  color: #b6b6b6;
  margin-left: 140px;
}

.pushButton {
  width: 180px;
  height: 50px;
  background: #349afe;
  border-radius: 10px;
  font-size: 26px;

  font-weight: 400;
  color: #ffffff;
  line-height: 50px;
  text-align: center;
}

.btnUploadfile {
  margin-left: 30px;
  width: 120px;
  height: 40px;
  background: #349afe;
  border-radius: 10px;
  font-size: 18px;

  font-weight: 400;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}

// 选择班级组件
.selectClass-box {
  width: 761px;
  max-height: 300px;
  padding: 0px 20px 20px 20px;
  box-sizing: border-box;
  overflow: scroll;
}

.publicMarginTop {
  margin-top: 30px;
}

.resourceType-box {
  width: 599px;
}

.useResources-box {
  width: 262px;
}

.btn-box {
  position: absolute;
  width: 410px;
  bottom: 80px;
}

.van-checkbox {
  margin-top: 20px;
}
</style>
